// @flow
import React, { useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useGetSPUserCommitMonthlyPricingViewQuery } from '@streaming-projects/service-definitions/streamingProjectsApi';
import { DataFetcherContainer } from '@presentational/DataFetcherContainer';
import { MonthlySpendSummaryContainer } from '@components/common/MonthlySpendSummaryContainer';
import { shouldSkipDataFetching } from '@src/common-utils/utils';
import { getMonthsAndYearsTransformedMonthlySpendSummary } from '@streaming-projects/utils';

import { useShouldPricingBeDisabled } from '../useShouldPricingBeEnabled';

export const SPUserCommitMonthlySummaryContainerWrapper = () => {
  const params = useParams();

  const dataFetchingArgs = useMemo(
    () => [{ ...params }, { skip: shouldSkipDataFetching(params) }],
    [params]
  );

  const dataFetchingFunction = useCallback(useGetSPUserCommitMonthlyPricingViewQuery, []);

  const shouldPricingBeDisabled = useShouldPricingBeDisabled();

  return (
    <DataFetcherContainer
      dataFetchingArgs={dataFetchingArgs}
      dataFetchingFunction={dataFetchingFunction}
    >
      {(data) => {
        const monthlySpendSummary = getMonthsAndYearsTransformedMonthlySpendSummary(
          data?.commit_cloud_monthly_spends
        );

        return (
          <MonthlySpendSummaryContainer
            columnNamesToPin={[]}
            columnsBasedOnTotalRow={true}
            disabled={shouldPricingBeDisabled}
            monthlySpendSummary={monthlySpendSummary}
            valuesAreCurrencies={false}
          />
        );
      }}
    </DataFetcherContainer>
  );
};
